import { render, staticRenderFns } from "./warn-instant.vue?vue&type=template&id=73f495e6&"
import script from "./warn-instant.vue?vue&type=script&lang=js&"
export * from "./warn-instant.vue?vue&type=script&lang=js&"
import style0 from "./warn-instant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports